import { RocketLaunchIcon } from "@heroicons/react/24/solid";
import * as React from "react";
import { IconBadge } from "../../../components/Badges/IconBadge";

export const ComingSoonBadge: React.FC = () => {
  return <IconBadge color="orange" icon={<RocketLaunchIcon />} label="Coming soon" />;
};
ComingSoonBadge.displayName = "ComingSoonBadge";
